import { useMemo } from "react";

import { colorsPalettes } from "@similarweb/styles";

import { useUserdataBenchmarkQuery } from "app/pages/benchmark-tracker/queries/useUserdataBenchmarkQuery";
import { useTranslation } from "pro-features/components/WithTranslation";

export const useLegends = () => {
    const translate = useTranslation();
    const { data, isLoading } = useUserdataBenchmarkQuery();

    const myLegend = useMemo(
        () => ({
            id: "you",
            name: data?.primaryDomains[0] || translate("common.you"),
            color: colorsPalettes.blue[400],
        }),
        [data, translate],
    );
    const competitorsLegend = useMemo(
        () => ({
            id: "competitors",
            name: translate("bt.report.channels.me-vs-competitors-chart.competitors-legend.name"),
            color: colorsPalettes.carbon[50],
        }),
        [translate],
    );

    const legendDataAdapter = () => [myLegend, competitorsLegend];

    return {
        competitorsLegend,
        isLoading,
        legendDataAdapter,
        myLegend,
    };
};
